import React from 'react';

import { NotificationPreferences } from './components';

// ─────────────────────────────────────────────────────────────────────

export const NotificationPreferencesLoading = (props: Props) => {
  const { title } = props;

  return (
    <NotificationPreferences.Container title={title}>
      <NotificationPreferences.Skeleton />
      <NotificationPreferences.Skeleton />
    </NotificationPreferences.Container>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  title: string;
};
